import React from 'react'
import { Box, Modal } from '@mui/material';
import CancelPresentationIconButton from '../../../common/components/Buttons/CancelPresentationIconButton';
import { format } from 'date-fns';
import { useEMRGeneralContext } from '../newGeneralEmr/EMRContextGeneral';

export default function PastDiagnosis(props) {
  const {   patientHistoryData,setPatientHistoryData}=props;
  return (
    <div>
    <Modal
     open={props.openPastDiagnosis}
     aria-labelledby="modal-modal-title"
     aria-describedby="modal-modal-description"
   >
     <Box
       sx={{
         position: "absolute",
         top: "50%",
         left: "50%",
         transform: "translate(-50%, -50%)",
         width: "50%",
         height: "60%",
         overflowY: "scroll",
         bgcolor: "background.paper",
         boxShadow: 24,
         p: 4,
       }}
     >
       <div className="text-base font-semibold  mb-4 flex justify-between">
         <h1>Past Diagnosis</h1>
         <div className="-mt-2">
           <CancelPresentationIconButton
             onClick={() => {
               props.setOpenPastDiagnosis(false);
             }}
           />
         </div>
       </div>
       <div className='flex flex-wrap gap-2'>
         {
           patientHistoryData?.historyDepartmentWise?.diagnosis?.length > 0 ? (
             <>
             {patientHistoryData?.historyDepartmentWise?.diagnosis.map((row)=>(
              <div className='grid grid-cols-1'>
              <h1 className='font-semibold text-[16px] text-gray-500 ml-2'>{format(new Date(row.date),"dd MMM yyyy")}</h1>
              <span key={row.id} className='border border-blue-500 text-center text-blue-700 rounded-xl p-[5px]'>{row.icd}</span>
              </div>
             ))}

             </>
           ):("")
         }
       </div>

       <div>
      
       </div>
      
     </Box>
   </Modal>
 </div>
  )
}
